export default __webpack_public_path__ + "static/media/settings.fddecaea.svg";